import styles from './EmailTemplatesPopover.module.scss';

import { Popover } from '@mui/material';

import { settings, useSetting } from '@work4all/data/lib/settings';

import { EMailTemplate } from '@work4all/models/lib/Classes/EMailTemplate.entity';
import { EMailTemplateKind } from '@work4all/models/lib/Enums/EMailTemplateKind.enum';

import { EmailTemplatePicker } from '../entity-picker/email-template-picker/EmailTemplatePicker';

interface EmailTemplatesPopoverProps {
  open: boolean;
  anchorEl: Element;
  onClose: () => void;
  onTemplateClick: (template: EMailTemplate | null) => void;
  eMailTemplateKind: EMailTemplateKind;
  noTemplate?: boolean;
}

export const EmailTemplatesPopover = ({
  open,
  anchorEl,
  onClose,
  ...rest
}: EmailTemplatesPopoverProps) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      classes={{
        root: styles.root,
        paper: styles.paper,
      }}
    >
      <EmailTemplatesPopoverInternal {...rest} />
    </Popover>
  );
};

const EmailTemplatesPopoverInternal = ({
  onTemplateClick,
  eMailTemplateKind,
  noTemplate,
}: Pick<
  EmailTemplatesPopoverProps,
  'onTemplateClick' | 'eMailTemplateKind' | 'noTemplate'
>) => {
  const { value: standardTemplates, set: setStandardTemplates } = useSetting(
    settings.standardEmailTemplates()
  );

  return (
    <EmailTemplatePicker
      value={{ eMailTemplateKind }}
      onChange={onTemplateClick}
      standardTemplates={standardTemplates}
      setStandardTemplates={setStandardTemplates}
      noTemplate={noTemplate}
      layout="simple"
      eMailTemplateKind={eMailTemplateKind}
    />
  );
};
